module.exports = __webpack_public_path__ + "static/media/kaustubh_kharat.ca2231b3.png";